import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Form,
  Modal,
  Badge,
  Image,
  Table,
  InputGroup,
  FormControl,
  Dropdown,
  Container,
} from "react-bootstrap";
import { PencilSquare, Trash, Eye, Funnel, Search, } from "react-bootstrap-icons";
import axios from "../../api/axios";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { toast } from "react-toastify";
import Header from "../../layouts/Header";
import { useSelector } from "react-redux";

const ViewLevelRewards = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [levelAccess, setLevelAccess] = useState([]);
    
    console.log("Access :", access);
    
    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("ViewLevelRewards:")
            );
            setLevelAccess(filteredAccess);
        } 
    }, [access]);
    
    console.log("Menu Access:", levelAccess);

    const accessToken = localStorage.getItem('authToken');
    const [rewardsData, setRewardsData] = useState([]);
    const [rewards, setRewards] = useState([]);
    const [filteredRewards, setFilteredRewards] = useState([]);
    const [levels, setLevels] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedReward, setSelectedReward] = useState(null);
    const [viewModal, setViewModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [singleLevelRewardData, setSingleLevelRewardData] = useState({});
    const [editBirthDayCouponInfo, setEditBirthDayCouponInfo] = useState({});
    const [editBOGODetails, setEditBOGODetails] = useState({});
    const [editSizeUpgradeDetails, setEditSizeUpgradeDetails] = useState({});
    const [editPointBoosterDetails, setEditPointBoosterDetails] = useState({});
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const animatedComponents = makeAnimated();
    const [birthDayCouponData, setBirthDayCouponData] = useState({});
    const [bogoCouponData, setBogoCouponData] = useState([]);
    const [filteredLevels, setFilteredLevels] = useState([]);
    const [couponsData, setCouponsData] = useState([]);
    const [secondRewardsData, setSecondRewardsData] = useState([]);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [levelRewardId, setLevelRewardId] = useState("");
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: '6px',
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d"
        }),
    };

    // const getRewardBadge = (reward) => {
    //     let variant = "primary";
    //     let text = "";
        
    //     if (reward.type === "COUPON") {
    //         variant = "success";
    //         text = "Coupon";
    //     } else if (reward.type === "REWARD") {
    //         variant = "warning";
    //         text = "Reward";
    //     }
        
    //     return <Badge bg={variant}>{text}</Badge>;
    // };

    const getRewardBadge = (reward) => {
        let variant = "primary";
        let text = "";
        
        if (reward.type === "COUPON") {
            variant = "success";
            if (reward.couponInfo?.couponData?.isBirthdayCoupon) {
                text = "Birthday Coupon";
            } else if (reward.couponInfo?.couponData?.isBogoCoupon) {
                text = "BOGO Coupon";
            } else if (reward.couponInfo?.isSizeUpgradeCoupon) {
                text = "Size Upgrade Coupon";
            } else {
                text = "Coupon";
            }
        } else if (reward.type === "REWARD") {
            variant = "warning";
            if (reward.rewardType === "POINT_BOOSTER") {
                text = "Point Booster";
            } else if (reward.rewardType === "GIFT") {
                text = "Gift Reward";
            } else {
                text = "Reward";
            }
        }
        
        return <Badge bg={variant}>{text}</Badge>;
    };

    const getRewardType = (reward) => {
        if (reward.couponInfo?.couponData?.isBogoCoupon) {
            return "BOGO Coupon";
        } else if (reward.couponInfo?.isSizeUpgradeCoupon) {
            return "Size Upgrade Coupon";
        } else if (reward.rewardType === "POINT_BOOSTER") {
            return "Point Booster";
        } else if (reward.rewardType === "GIFT") {
            return "Gift";
        } else {
            return "Birthday Coupon";
        }
    };

    const fetchBirthdayCouponData = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("settings", { headers });
            if (response?.data?.status === true) {
                const coupon = response?.data?.data?.settings?.couponInfo?.coupon;
                setBirthDayCouponData(coupon)
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const fetchBOGOCouponData = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("coupons", { headers });
            if (response?.data?.status === true) {
                const coupon = response?.data?.data?.coupons;
                const bogoCoupons = coupon.filter((coupon) => coupon.isBogoCoupon === true)
                setBogoCouponData(bogoCoupons)
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const fetchLevelsData = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("level", { headers });
            if (response?.data?.status === true) {
                const levels = response?.data?.data?.levels;
                setLevels(levels)
                filterLevels(levels)
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleFilterText = (e) => {
        const filterValue = e?.target?.value || "";

        if (filterValue === "") {
            setSecondRewardsData(rewardsData);
            return;
        }

        const filteredData = rewardsData?.filter((item) => item?.level?.sequenceNo === parseInt(filterValue));
        

        if (filteredData?.length > 0) {
            setSecondRewardsData(filteredData);
        } else {
            setSecondRewardsData(rewardsData);
        }
    };

    const couponsList = couponsData
        .filter(item =>
            (item.sizeUpgradeAddon !== null && item.sizeUpgradeAddon !== undefined) ||
            (item.newSizeUpgradeAddon !== null && item.newSizeUpgradeAddon !== undefined)
        )
        .map(item => ({
            value: item._id,
            label: `${item.title} (${item.couponCode})`
        }));

    const handleSelectChange = (selected) => {
        setSelectedOptions(selected);
    };

    const fetchCouponData = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("coupons", { headers });

            if (response?.data?.status === true) {
                setCouponsData(response?.data?.data?.coupons);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const filterLevels = (levels) => {
        const level = levels?.filter((item) => item.title !== "Level 1");
        setFilteredLevels(level)
    }

    const fetchRewardsData = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("level-reward", { headers });

            if (response?.data?.status === true) {
                const levelRewards = response?.data?.data?.levelRewards
                console.log("Level Rewards :", levelRewards);
                
                setRewardsData(levelRewards)
                setSecondRewardsData(levelRewards)
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    }

    const handleDeleteModal = (data) => {
        setOpenDeleteModal(true)
        setLevelRewardId(data?._id)
    }

    const handleDelete = async () => {
        setShowDeleteModal(false);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.delete(`level-reward/${selectedReward._id}`, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                fetchRewardsData();
            }
        } catch (error) {
            toast.error("Failed to delete reward", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        }
    };

    const deleteLevelReward = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                _id: levelRewardId
            }

            const response = await axios.delete(`level-reward`, { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                fetchRewardsData();
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response.status === 403) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    }

    const handleOpenEditModal = (rewardId) => {
        setOpenEditModal(true);
        fetchSingleLevelRewardDetails(rewardId)
    }

    const fetchSingleLevelRewardDetails = async (id) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get(`level-reward?_id=${id}`, { headers });

            if (response?.data?.status === true) {
                const levelRewards = response?.data?.data?.levelRewards;
                setSingleLevelRewardData(levelRewards)
                if (levelRewards?.applyingConditions === null) {
                    setEditBirthDayCouponInfo({
                        _id: levelRewards?._id,
                        level: levelRewards?.level?._id,
                        type: levelRewards?.type,
                        couponData: levelRewards?.couponInfo?.couponData?._id
                    })
                }

                if (levelRewards?.couponInfo?.couponData?.isBogoCoupon === true) {
                    setEditBOGODetails({
                        _id: levelRewards?._id,
                        level: levelRewards?.level?._id,
                        type: levelRewards?.type,
                        couponData: levelRewards?.couponInfo?.couponData?._id,
                        interval: levelRewards?.applyingConditions?.interval,
                        value: levelRewards?.applyingConditions?.value,
                        numberOfTimes: levelRewards?.applyingConditions?.numberOfTimes
                    })
                }

                if (levelRewards?.rewardType !== undefined || levelRewards?.rewardType !== "") {
                    setEditPointBoosterDetails({
                        _id: levelRewards?._id,
                        level: levelRewards?.level?._id,
                        type: levelRewards?.type,
                        rewardType: levelRewards?.rewardType,
                        interval: levelRewards?.applyingConditions?.interval,
                        value: levelRewards?.applyingConditions?.value,
                        numberOfTimes: levelRewards?.applyingConditions?.numberOfTimes
                    })
                }

                if (levelRewards?.rewardType !== undefined || levelRewards?.rewardType === "") {
                    setEditSizeUpgradeDetails({
                        _id: levelRewards?._id,
                        level: levelRewards?.level?._id,
                        type: levelRewards?.type,
                        interval: levelRewards?.applyingConditions?.interval,
                        value: levelRewards?.applyingConditions?.value,
                        numberOfTimes: levelRewards?.applyingConditions?.numberOfTimes
                    })
                    const couponsData = levelRewards?.couponInfo?.couponData?.map((item) => ({
                        value: item._id,
                        label: `${item.title} (${item.couponCode})`
                    }))

                    setSelectedOptions(couponsData)
                }
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    }

    const handleEditBirthDayRewardChange = (e) => {
        const { name, value } = e.target;
        setEditBirthDayCouponInfo((prev) => ({ ...prev, [name]: value }))
    }

    const editBirthDaySubmit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            if (editBirthDayCouponInfo?.type === "REWARD") {
                delete editBirthDayCouponInfo?.couponData
            }

            const response = await axios.put("level-reward", editBirthDayCouponInfo, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setOpenEditModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (
                    error.response?.status === 406
                ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (
                    error.response?.status === 412
                ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleEditBOGORewardChange = (e) => {
        const { name, value } = e.target;
        if (name === "type" && value === "REWARD") {
            setEditBOGODetails((prev) => ({ ...prev, couponsData: "" }))
        }
        setEditBOGODetails((prev) => ({ ...prev, [name]: value }));
    }

    const editBOGOSubmit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            let data = {
                _id: editBOGODetails?._id,
                level: editBOGODetails?.level,
                type: editBOGODetails?.type,
                couponData: editBOGODetails?.couponData,
                applyingConditions: {
                    interval: editBOGODetails?.interval,
                    value: Number(editBOGODetails?.value),
                    numberOfTimes: Number(editBOGODetails?.numberOfTimes)
                }
            }

            if (data?.type === "REWARD") {
                delete data?.couponData
            }

            if (data?.applyingConditions?.value === "null") {
                delete data?.applyingConditions?.value
            }

            const response = await axios.put("level-reward", data, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setOpenEditModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (
                    error.response?.status === 406
                ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (
                    error.response?.status === 412
                ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleEditPointBoosterRewardChange = (e) => {
        const { name, value } = e.target;
        setEditPointBoosterDetails((prev) => ({ ...prev, [name]: value }))
    }

    const editPointBoosterSubmit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            let data = {
                _id: editPointBoosterDetails?._id,
                level: editPointBoosterDetails?.level,
                type: editPointBoosterDetails?.type,
                rewardType: editPointBoosterDetails?.rewardType,
                applyingConditions: {
                    interval: editPointBoosterDetails?.interval,
                    value: Number(editPointBoosterDetails?.value)
                }
            }

            const response = await axios.put("level-reward", data, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setOpenEditModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (
                    error.response?.status === 406
                ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (
                    error.response?.status === 412
                ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleEditSizeUpgradeChange = (e) => {
        const { name, value } = e.target
        setEditSizeUpgradeDetails((prev) => ({ ...prev, [name]: value }))
    }

    const editSizeUpgradeSubmit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const selectedCoupons = selectedOptions.map((option) => option.value);

            let data = {
                _id: editSizeUpgradeDetails?._id,
                level: editSizeUpgradeDetails?.level,
                type: editSizeUpgradeDetails?.type,
                couponData: selectedCoupons,
                applyingConditions: {
                    interval: editSizeUpgradeDetails?.interval,
                    value: Number(editSizeUpgradeDetails?.value),
                    numberOfTimes: Number(editSizeUpgradeDetails?.numberOfTimes)
                }
            }

            const response = await axios.put("level-reward", data, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setOpenEditModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (
                    error.response?.status === 406
                ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (
                    error.response?.status === 412
                ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleOpenViewModal = (rewardId) => {
        setOpenViewModal(true)
        fetchSingleLevelRewardDetails(rewardId)
    }

    const findDay = (num) => {
        let day = num === 0 ? "SUNDAY" : num === 1 ? "MONDAY" : num === 2 ? "TUESDAY" : num === 3 ? "WEDNESDAY" : num === 4 ? "THURSDAY" : num === 5 ? "FRIDAY" : "SATURDAY"

        return day;
    }

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false)
    }

    // Add this useEffect for filtering
    useEffect(() => {
        let filtered = rewardsData;

        // Filter by level if selected
        if (selectedLevel) {
            filtered = filtered.filter(reward => reward.level._id === selectedLevel);
        }

        // Filter by search term if entered
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(reward => 
                reward.level.title.toLowerCase().includes(term) ||
                reward.type.toLowerCase().includes(term) ||
                (reward.rewardType && reward.rewardType.toLowerCase().includes(term)) ||
                (reward.couponInfo?.couponData?.title && reward.couponInfo.couponData.title.toLowerCase().includes(term))
            );
        }

        setSecondRewardsData(filtered);
    }, [selectedLevel, searchTerm, rewardsData]);

    useEffect(() => {
        fetchRewardsData();
        fetchCouponData()
        fetchLevelsData();
        fetchBirthdayCouponData();
        fetchBOGOCouponData()
    }, [])

    useEffect(() => {
        console.log("Hello in useEffect :");
        
        handleFilterText()
    }, [rewardsData])

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="mb-0 fw-semibold">LEVEL REWARDS MANAGEMENT</h4>
                </div>

                {/* Filters */}
                <Card className="mb-4">
                    <Card.Body>
                        <Row>
                            <Col md={4}>
                                <Form.Group>
                                <Form.Label className="fw-semibold">
                                    Filter by Level
                                </Form.Label>
                                <Form.Select
                                    value={selectedLevel}
                                    onChange={(e) => setSelectedLevel(e.target.value)}
                                >
                                    <option value="">All Levels</option>
                                    {levels.map((level) => (
                                        <option key={level._id} value={level._id}>
                                            {level.title}
                                        </option>
                                    ))}
                                </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={8}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold">
                                        Search Rewards
                                    </Form.Label>
                                    <InputGroup>
                                        <FormControl
                                            placeholder="Search by level name or reward type..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        <Button variant="outline-secondary">
                                            <Search />
                                        </Button>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Rewards Grid */}
                    <Container fluid>
                        {(levelAccess?.includes("ViewLevelRewards:get") || email === "contact@xpansecafe.com") && (
                            <Row className="shadow-sm" style={{ backgroundColor: 'whitesmoke' }}>
                                {secondRewardsData?.length > 0 ? (
                                    secondRewardsData?.map((reward) => (
                                    <Col key={reward?._id} xl={3} lg={4} md={6} className="mb-4">
                                        <Card className="h-100 shadow-sm mt-3">
                                            <div className="position-relative">
                                                <Image
                                                    src={reward?.level?.bannerImage}
                                                    alt={reward?.level?.title}
                                                    fluid
                                                    className="card-img-top rounded-top"
                                                    style={{ height: "150px", objectFit: "cover" }}
                                                />
                                                <Badge
                                                    bg="dark"
                                                    className="position-absolute top-0 end-0 m-2"
                                                >
                                                    Level {reward.level.sequenceNo}
                                                </Badge>
                                            </div>
                                            <Card.Body>
                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                    <h5 className="mb-0">{reward.level.title}</h5>
                                                    {getRewardBadge(reward)}
                                                </div>
                                                <p className="text-muted small mb-3">
                                                    Requires {reward.level.requiredPoints} points
                                                </p>
                                                <div className="d-flex justify-content-between">
                                                    {(levelAccess?.includes("ViewLevelRewards:get") || email === "contact@xpansecafe.com") && (
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => handleOpenViewModal(reward._id)}
                                                        >
                                                            <Eye className="me-1" /> View
                                                        </Button>
                                                    )}
                                                    {(levelAccess?.includes("ViewLevelRewards:update") || email === "contact@xpansecafe.com") && (
                                                        <Button
                                                            variant="outline-secondary"
                                                            size="sm"
                                                            onClick={() => handleOpenEditModal(reward._id)}
                                                        >
                                                            <PencilSquare className="me-1" /> Edit
                                                        </Button>
                                                    )}
                                                    {(levelAccess?.includes("ViewLevelRewards:delete") || email === "contact@xpansecafe.com") && (
                                                        <Button
                                                            variant="outline-danger"
                                                            size="sm"
                                                            onClick={() => handleDeleteModal(reward)}
                                                        >
                                                            <Trash className="me-1" /> Delete
                                                        </Button>
                                                    )}
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    ))
                                ) : (
                                    <Col>
                                        <Card>
                                            <Card.Body className="text-center py-5">
                                            <h5>No rewards found</h5>
                                            <p className="text-muted">
                                                {selectedLevel || searchTerm
                                                ? "Try adjusting your filters"
                                                : "No rewards have been created yet"}
                                            </p>
                                            <Button variant="primary">Create New Reward</Button>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                )}
                            </Row>
                        )}
                    </Container>


                {/* View Modal */}
                <Modal show={openViewModal} onHide={() => setOpenViewModal(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Reward Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {singleLevelRewardData && (
                        <Row>
                            <Col md={5}>
                            <Image
                                src={singleLevelRewardData.level?.bannerImage}
                                alt={singleLevelRewardData.level?.title}
                                fluid
                                className="rounded"
                            />
                            <Table bordered className="mt-3">
                                <tbody>
                                <tr>
                                    <td className="fw-bold">Level</td>
                                    <td>{singleLevelRewardData.level?.title}</td>
                                </tr>
                                <tr>
                                    <td className="fw-bold">Sequence</td>
                                    <td>{singleLevelRewardData.level?.sequenceNo}</td>
                                </tr>
                                <tr>
                                    <td className="fw-bold">Required Points</td>
                                    <td>{singleLevelRewardData.level?.requiredPoints}</td>
                                </tr>
                                <tr>
                                    <td className="fw-bold">Reward Type</td>
                                    <td>{getRewardType(singleLevelRewardData)}</td>
                                </tr>
                                </tbody>
                            </Table>
                            </Col>
                            <Col md={7}>
                            <h5>Reward Information</h5>
                            {singleLevelRewardData.applyingConditions && (
                                <>
                                <Table bordered>
                                    <thead>
                                    <tr>
                                        <th>Condition</th>
                                        <th>Value</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Interval</td>
                                        <td>
                                        {singleLevelRewardData.applyingConditions.interval}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Day</td>
                                        <td>
                                        {singleLevelRewardData.applyingConditions.value === null
                                            ? "Any day"
                                            : findDay(singleLevelRewardData.applyingConditions.value)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Number of Times</td>
                                        <td>
                                        {singleLevelRewardData.applyingConditions.numberOfTimes}
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>
                                </>
                            )}
                            {singleLevelRewardData.couponInfo && (
                                <>
                                <h6 className="mt-4">Coupon Details</h6>
                                {Array.isArray(singleLevelRewardData.couponInfo.couponData) ? (
                                    singleLevelRewardData.couponInfo.couponData.map((coupon) => (
                                    <Card key={coupon._id} className="mb-2">
                                        <Card.Body>
                                        <h6>{coupon.title}</h6>
                                        <p className="mb-1">
                                            <strong>Code:</strong> {coupon.couponCode}
                                        </p>
                                        <p className="mb-1">
                                            <strong>Type:</strong> {coupon.usageType}
                                        </p>
                                        </Card.Body>
                                    </Card>
                                    ))
                                ) : (
                                    <Card>
                                    <Card.Body>
                                        <h6>
                                        {singleLevelRewardData.couponInfo.couponData?.title}
                                        </h6>
                                        <p className="mb-1">
                                        <strong>Code:</strong>{" "}
                                        {singleLevelRewardData.couponInfo.couponData?.couponCode}
                                        </p>
                                        <p className="mb-1">
                                        <strong>Type:</strong>{" "}
                                        {singleLevelRewardData.couponInfo.couponData?.usageType}
                                        </p>
                                    </Card.Body>
                                    </Card>
                                )}
                                </>
                            )}
                            </Col>
                        </Row>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setOpenViewModal(false)}>
                        Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Delete Confirmation Modal */}
                <Modal
                    show={openDeleteModal}
                    onHide={handleCloseDeleteModal}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Deletion</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete this reward? This action cannot be
                        undone.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                        variant="secondary"
                        onClick={handleCloseDeleteModal}
                        >
                        Cancel
                        </Button>
                        <Button 
                        variant="danger" 
                        onClick={deleteLevelReward}
                        disabled={isDeleteBtnLoading}
                        >
                        {isDeleteBtnLoading ? "Deleting..." : "Delete"}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Edit Modal */}
                {openEditModal && (
                    <Modal
                        show={openEditModal}
                        onHide={() => setOpenEditModal(false)}
                        size="lg"
                        centered
                        aria-labelledby="edit-level-reward-modal"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="edit-level-reward-modal">
                                EDIT LEVEL REWARD
                            </Modal.Title>
                        </Modal.Header>

                        {singleLevelRewardData &&
                            (singleLevelRewardData?.applyingConditions === null ||
                                singleLevelRewardData?.applyingConditions === undefined) && (
                                <Form onSubmit={editBirthDaySubmit}>
                                <Modal.Body>
                                    <Row className="g-3">
                                    <Col md={4}>
                                        <Form.Group controlId="editLevelSelect">
                                            <Form.Label className="fw-semibold">
                                                Select Level <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                onChange={handleEditBirthDayRewardChange}
                                                name="level"
                                                value={editBirthDayCouponInfo?.level}
                                            >
                                                <option value="">Select Level</option>
                                                {levels.map((level) => (
                                                <option key={level._id} value={level._id}>
                                                    {level.title}
                                                </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group controlId="editTypeSelect">
                                        <Form.Label className="fw-semibold">
                                            Select Type <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            onChange={handleEditBirthDayRewardChange}
                                            name="type"
                                            value={editBirthDayCouponInfo?.type}
                                        >
                                            <option value="">Select Type</option>
                                            <option value="COUPON">COUPON</option>
                                            <option value="REWARD">REWARD</option>
                                        </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group controlId="editCouponSelect">
                                        <Form.Label className="fw-semibold">
                                            Select Coupon <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            onChange={handleEditBirthDayRewardChange}
                                            name="couponData"
                                            value={editBirthDayCouponInfo?.couponData}
                                            disabled={editBirthDayCouponInfo?.type === "REWARD"}
                                        >
                                            <option value="">Select Coupon</option>
                                            <option value={birthDayCouponData?._id}>
                                            {birthDayCouponData?.title}
                                            </option>
                                        </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                    variant="primary"
                                    type="submit"
                                    disabled={isEditBtnLoading}
                                    >
                                    {isEditBtnLoading ? "Saving..." : "SAVE CHANGES"}
                                    </Button>
                                </Modal.Footer>
                                </Form>
                            )}

                        {singleLevelRewardData &&
                        singleLevelRewardData?.couponInfo?.couponData?.isBogoCoupon ===
                            true && (
                            <Form onSubmit={editBOGOSubmit}>
                            <Modal.Body>
                                <Row className="g-3">
                                <Col md={4}>
                                    <Form.Group controlId="editBogoLevel">
                                    <Form.Label className="fw-semibold">
                                        Select Level <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditBOGORewardChange}
                                        name="level"
                                        value={editBOGODetails?.level}
                                    >
                                        <option value="">Select Level</option>
                                        {filteredLevels?.map((level) => (
                                        <option key={level._id} value={level._id}>
                                            {level.title}
                                        </option>
                                        ))}
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group controlId="editBogoType">
                                    <Form.Label className="fw-semibold">
                                        Select Type <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditBOGORewardChange}
                                        name="type"
                                        value={editBOGODetails?.type}
                                    >
                                        <option value="">Select Type</option>
                                        <option value="COUPON">COUPON</option>
                                        <option value="REWARD">REWARD</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group controlId="editBogoCoupon">
                                    <Form.Label className="fw-semibold">
                                        Select Coupon <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        disabled={editBOGODetails?.type === "REWARD"}
                                        size="sm"
                                        onChange={handleEditBOGORewardChange}
                                        name="couponData"
                                        value={editBOGODetails?.couponData}
                                    >
                                        <option value="">Select Coupon</option>
                                        {bogoCouponData.map((level) => (
                                        <option key={level._id} value={level._id}>
                                            {level.title}
                                        </option>
                                        ))}
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <hr />
                                    <h6 className="fw-bold">Applying Conditions</h6>
                                    <hr />
                                </Col>

                                <Col md={4}>
                                    <Form.Group controlId="editBogoInterval">
                                    <Form.Label className="fw-semibold">
                                        Time Interval <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditBOGORewardChange}
                                        name="interval"
                                        value={editBOGODetails?.interval}
                                    >
                                        <option value="">Select Time Interval</option>
                                        <option value="WEEKLY">WEEKLY</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group controlId="editBogoDay">
                                    <Form.Label className="fw-semibold">
                                        Select Day <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditBOGORewardChange}
                                        name="value"
                                        value={editBOGODetails?.value}
                                    >
                                        <option value="">Select Day</option>
                                        <option value="0">SUNDAY</option>
                                        <option value="1">MONDAY</option>
                                        <option value="2">TUESDAY</option>
                                        <option value="3">WEDNESDAY</option>
                                        <option value="4">THURSDAY</option>
                                        <option value="5">FRIDAY</option>
                                        <option value="6">SATURDAY</option>
                                        <option value="null">ANY DAY OF THE WEEK</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group controlId="editBogoTimes">
                                    <Form.Label className="fw-semibold">
                                        Number Of Times{" "}
                                        <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditBOGORewardChange}
                                        name="numberOfTimes"
                                        value={editBOGODetails?.numberOfTimes}
                                    >
                                        <option value="">Number Of Times</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                variant="primary"
                                type="submit"
                                disabled={isEditBtnLoading}
                                >
                                {isEditBtnLoading ? "Saving..." : "SAVE CHANGES"}
                                </Button>
                            </Modal.Footer>
                            </Form>
                        )}

                        {singleLevelRewardData &&
                        singleLevelRewardData?.rewardType !== "" &&
                        singleLevelRewardData?.rewardType !== null &&
                        singleLevelRewardData?.rewardType !== undefined && (
                            <Form onSubmit={editPointBoosterSubmit}>
                            <Modal.Body>
                                <Row className="g-3">
                                <Col md={4}>
                                    <Form.Group controlId="editPointLevel">
                                    <Form.Label className="fw-semibold">
                                        Select Level <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditPointBoosterRewardChange}
                                        name="level"
                                        value={editPointBoosterDetails?.level}
                                    >
                                        <option value="">Select Level</option>
                                        {filteredLevels?.map((level) => (
                                        <option key={level._id} value={level._id}>
                                            {level.title}
                                        </option>
                                        ))}
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group controlId="editPointType">
                                    <Form.Label className="fw-semibold">
                                        Select Type <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditPointBoosterRewardChange}
                                        name="type"
                                        value={editPointBoosterDetails?.type}
                                    >
                                        <option value="">Select Type</option>
                                        <option value="COUPON">COUPON</option>
                                        <option value="REWARD">REWARD</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group controlId="editPointRewardType">
                                    <Form.Label className="fw-semibold">
                                        Reward Type <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditPointBoosterRewardChange}
                                        name="rewardType"
                                        value={editPointBoosterDetails?.rewardType}
                                    >
                                        <option value="">Select Reward Type</option>
                                        <option value="POINT_BOOSTER">POINT BOOSTER</option>
                                        <option value="GIFT">GIFT</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <hr />
                                    <h6 className="fw-bold">Applying Conditions</h6>
                                    <hr />
                                </Col>

                                <Col md={6}>
                                    <Form.Group controlId="editPointInterval">
                                    <Form.Label className="fw-semibold">
                                        Time Interval <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditPointBoosterRewardChange}
                                        name="interval"
                                        value={editPointBoosterDetails?.interval}
                                    >
                                        <option value="">Select Time Interval</option>
                                        <option value="WEEKLY">WEEKLY</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group controlId="editPointDay">
                                    <Form.Label className="fw-semibold">
                                        Select Day <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditPointBoosterRewardChange}
                                        name="value"
                                        value={editPointBoosterDetails?.value}
                                    >
                                        <option value="">Select Day</option>
                                        <option value="0">SUNDAY</option>
                                        <option value="1">MONDAY</option>
                                        <option value="2">TUESDAY</option>
                                        <option value="3">WEDNESDAY</option>
                                        <option value="4">THURSDAY</option>
                                        <option value="5">FRIDAY</option>
                                        <option value="6">SATURDAY</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" type="submit">
                                SAVE CHANGES
                                </Button>
                            </Modal.Footer>
                            </Form>
                        )}

                        {singleLevelRewardData &&
                        singleLevelRewardData?.couponInfo?.isSizeUpgradeCoupon ===
                            true && (
                            <Form onSubmit={editSizeUpgradeSubmit}>
                            <Modal.Body>
                                <Row className="g-3">
                                <Col md={4}>
                                    <Form.Group controlId="editSizeLevel">
                                    <Form.Label className="fw-semibold">
                                        Select Level <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditSizeUpgradeChange}
                                        name="level"
                                        value={editSizeUpgradeDetails?.level}
                                    >
                                        <option value="">Select Level</option>
                                        {filteredLevels.map((level) => (
                                        <option key={level._id} value={level._id}>
                                            {level.title}
                                        </option>
                                        ))}
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group controlId="editSizeType">
                                    <Form.Label className="fw-semibold">
                                        Select Type <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditSizeUpgradeChange}
                                        name="type"
                                        value={editSizeUpgradeDetails?.type}
                                    >
                                        <option value="">Select Type</option>
                                        <option value="COUPON">COUPON</option>
                                        <option value="REWARD">REWARD</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={12}>
                                    <Form.Group controlId="editSizeCoupons">
                                    <Form.Label className="fw-semibold">
                                        Select Coupons{" "}
                                        <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Select
                                        isMulti
                                        components={animatedComponents}
                                        value={selectedOptions}
                                        onChange={handleSelectChange}
                                        options={couponsList}
                                        styles={customStyles}
                                        placeholder="Select Coupons"
                                        closeMenuOnSelect={false}
                                        theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 0,
                                        colors: {
                                            ...theme.colors,
                                            primary25: "#e9ecef",
                                            primary: "#007bff",
                                        },
                                        })}
                                    />
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <hr />
                                    <h6 className="fw-bold">Applying Conditions</h6>
                                    <hr />
                                </Col>

                                <Col md={4}>
                                    <Form.Group controlId="editSizeInterval">
                                    <Form.Label className="fw-semibold">
                                        Time Interval <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditSizeUpgradeChange}
                                        name="interval"
                                        value={editSizeUpgradeDetails?.interval}
                                    >
                                        <option value="">Select Interval</option>
                                        <option value="WEEKLY">WEEKLY</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group controlId="editSizeDay">
                                    <Form.Label className="fw-semibold">
                                        Select Day <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditSizeUpgradeChange}
                                        name="value"
                                        value={editSizeUpgradeDetails?.value ?? "null"}
                                    >
                                        <option value="">Select Day</option>
                                        <option value="0">SUNDAY</option>
                                        <option value="1">MONDAY</option>
                                        <option value="2">TUESDAY</option>
                                        <option value="3">WEDNESDAY</option>
                                        <option value="4">THURSDAY</option>
                                        <option value="5">FRIDAY</option>
                                        <option value="6">SATURDAY</option>
                                        <option value="null">ANY DAY OF THE WEEK</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group controlId="editSizeTimes">
                                    <Form.Label className="fw-semibold">
                                        Number Of Times{" "}
                                        <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        onChange={handleEditSizeUpgradeChange}
                                        name="numberOfTimes"
                                        value={editSizeUpgradeDetails?.numberOfTimes}
                                    >
                                        <option value="">Number Of Times</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" type="submit">
                                SAVE CHANGES
                                </Button>
                            </Modal.Footer>
                            </Form>
                        )}
                    </Modal>
                )}
            </div>
        </React.Fragment>
    );
};

export default ViewLevelRewards;